import { Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react"

interface Props {
    isOpen: boolean,
    onClose: any,
    status: boolean
}

const ActiveLife = ({ isOpen, onClose, status }: Props) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{status ? 'Desativar' : 'Ativar'} Vida</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    Confirme a {status ? 'desativação' : 'ativação'}.
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button variant="ghost" onClick={onClose}>Cancelar</Button>
                        <Button colorScheme={status ? 'red' : 'green'} onClick={onClose}>{status ? 'Desativar' : 'Ativar'}</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ActiveLife
